import OurDataPage from '@screens/our-data'

export default OurDataPage
